import { render, staticRenderFns } from "./assint.vue?vue&type=template&id=72b2d1d0&scoped=true&"
import script from "./assint.vue?vue&type=script&lang=js&"
export * from "./assint.vue?vue&type=script&lang=js&"
import style0 from "./assint.vue?vue&type=style&index=0&id=72b2d1d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2d1d0",
  null
  
)

export default component.exports